import SwitcherList from "./switcher";

import * as React from "react";
import * as ReactDOM from "react-dom";

import _vj from "video.js";

// @ts-ignore
const videojs = window.videojs || _vj;

const vjsComponent = videojs.getComponent("Component");

let playerArr: any;

class VjsSwitcherList extends vjsComponent {
  private player: any;
  constructor(player: any, options: any) {
    super(player, options);
    this.player = player;
    player.ready(() => {
      this.mount();
    });

    /* Remove React root when component is destroyed */
    this.on("dispose", () => {
      ReactDOM.unmountComponentAtNode(this.el());
    });
  }

  public mount() {
    ReactDOM.render(
      <SwitcherList vjsComponent={this} playerArr={playerArr} player={this.player} />,
      this.el()
    );
  }
}

const injectComponent = (data: any) => {
  playerArr = data;
};

export { VjsSwitcherList };
export { injectComponent };



// WEBPACK FOOTER //
// ./src/pc/component/videoPlayerComtainer/index.tsx